module.exports = __webpack_public_path__ + "img/YEtVyDZe_400x400.ed6fdd14.jpg";